module.exports = __webpack_public_path__ + "static/media/plusShape.7f0fdd23.svg";